import { setContains } from "./collections";

export const sortNatural = (keys: any[]) => [...sortSetNatural(new Set(keys))];

export const sortSetNatural = (keys: Set<any>) => {
  const looksLikeDays = sortByDays();
  if (looksLikeDays) return looksLikeDays;

  const looksLikeMonths = sortByMonths();
  if (looksLikeMonths) return looksLikeMonths;

  const looksLikeHours = sortByHours();
  if (looksLikeHours) return looksLikeHours;

  const looksOrdinal = sortOrdinally();
  if (looksOrdinal) return looksOrdinal;

  return keys;

  function sortByDays() {
    const days = new Set(
      [...keys].map((key) => `${key}`.slice(0, 3).toLowerCase())
    );
    const cal = ["sun", "mon", "tue", "wed", "thu", "fri", "sat", "__v"];
    if (setContains(new Set(cal), days)) {
      return new Set(
        [...keys]
          .sort(
            (a, b) =>
              cal.indexOf(b.slice(0, 3).toLowerCase()) -
              cal.indexOf(a.slice(0, 3).toLowerCase())
          )
          .reverse()
      );
    }
    // selecting by event day sometimes spans months,
    // giving us another foramt:  dd/mm
    if (
      [...keys].every(
        (key) => key === "__VZBL::null__" || `${key}`.match(/^\d\d\/\d\d$/)
      )
    ) {
      return new Set(
        [...keys].sort((a, b) => {
          const [aM, aD] = a.split("/");
          const [bM, bD] = b.split("/");
          if (aM === bM) return aD - bD;
          return aM - bM;
        })
      );
    }

    // the format for 'day' is now yy/dd/mm - making it possible to sort data that cross over january first
    if (
      [...keys].every(
        (key) =>
          key === "__VZBL::null__" || `${key}`.match(/^\d\d\/\d\d\/\d\d$/)
      )
    ) {
      return new Set([...keys].sort()); // alpha order is correct
    }
  }

  function sortByMonths() {
    const mos = new Set(
      [...keys].map((key) => `${key}`.slice(0, 3).toLowerCase())
    );
    const cal = [
      "jan",
      "feb",
      "mar",
      "apr",
      "may",
      "jun",
      "jul",
      "aug",
      "sep",
      "oct",
      "nov",
      "dec",
      "__v",
    ];
    if (setContains(new Set(cal), mos)) {
      return new Set(
        [...keys]
          .sort(
            (a, b) =>
              cal.indexOf(b.slice(0, 3).toLowerCase()) -
              cal.indexOf(a.slice(0, 3).toLowerCase())
          )
          .reverse()
      );
    }
  }

  function sortByHours() {
    const hours = new Set([...keys].map((key) => `${key}`.toLowerCase()));
    const cal = [
      "12am",
      "1am",
      "01am",
      "2am",
      "02am",
      "3am",
      "03am",
      "4am",
      "04am",
      "5am",
      "05am",
      "6am",
      "06am",
      "7am",
      "07am",
      "8am",
      "08am",
      "9am",
      "09am",
      "10am",
      "11am",
      "12pm",
      "1pm",
      "01pm",
      "2pm",
      "02pm",
      "3pm",
      "03pm",
      "4pm",
      "04pm",
      "5pm",
      "05pm",
      "6pm",
      "06pm",
      "7pm",
      "07pm",
      "8pm",
      "08pm",
      "9pm",
      "09pm",
      "10pm",
      "11pm",
      "__vzbl::null__",
    ];
    if (setContains(new Set(cal), hours)) {
      return new Set(
        [...keys]
          .sort(
            (a, b) =>
              cal.indexOf(b.toLowerCase()) - cal.indexOf(a.toLowerCase())
          )
          .reverse()
      );
    }
  }

  function sortOrdinally() {
    if (
      [...keys].every(
        (key) =>
          key === "__VZBL::null__" ||
          `${key}`.toLowerCase().match(/^\d+(st|nd|rd|th)?$/)
      )
    ) {
      return new Set(
        [...keys]
          .sort(
            (a, b) => Number.parseInt(`${b}`, 10) - Number.parseInt(`${a}`, 10)
          )
          .reverse()
      );
    }
  }
};
